<template>
  <v-container class="pa-0">
    <download-excel
      class="primary--color"
      :fetch="getConsumerLoan"
      worksheet="untitled"
      :title="`${consumerName} Statement Of Account ${storeName}`"
      type="xls"
      :name="`${storeName}_${consumerName}_statement_of_account_${new Date().getTime()}.xls`"
      :fields="getFields()"
    >
      <v-btn
        block
        :loading="consumerLoanLoading || loading"
        color="primary"
      >Export</v-btn>
    </download-excel>
    <alert-success
      :toggle-dialog="success"
      title="Import Success"
      message="Data was Exported successfully"
    />
    <alert-error
      :toggle-dialog="error"
      title="Import Error!"
      :message="cnsmrErrors"
    />
  </v-container>
</template>
<script>
  // import writeExcel from '@/extra-functions/writeExcel.extra'
  import { errorHandler } from '@/extra-functions/store.extra'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  import consumerLoanRepository from '@/repositories/consumer-loan.repository'
  import { mapState } from 'vuex'
  import { apiVars } from '@/extra-functions/api-helper.extra'

  const errorDelay = searchDelay(100)
  const successDelay = searchDelay(100)
  const { dialog } = require('electron').remote
  const getConsumerLoanDelay = searchDelay()
  const showOpenDialogOptions = () => ({
    title: 'Export',
    filters: [{ name: 'Select Folder', extensions: [''] }],
    buttonLabel: 'select',
    properties: [
      'openDirectory',
    ],
  })

  const overDueRemark = (date1, balance) => {
    const dateNow = new Date(new Date().setHours(0, 0, 0, 0))
    const dateDue = new Date(new Date(date1).setHours(0, 0, 0, 0))
    if (balance > 0 && dateDue < dateNow) return 'Overdue'
    return ''
  }

  const mapConsumers = e => {
    const { debt, paid } = e
    const balance = debt - paid
    return {
      crNo: e.id,
      debt,
      paid,
      balance,
      remark: overDueRemark(e.date_due, balance),
      dateDue: e.date_due,
      dateLoaned: e.date_loaned,
      datePaid: e.date_paid,
    }
  }

  const inputVars = () => ({
    cnsmrList: [],
    cnsmrErrors: [],
    consumerLoading: false,
    success: false,
    error: false,
  })

  export default {
    name: 'export-consumers',
    props: {
      consumerId: {
        type: String,
        default: '',
      },
      consumerName: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    created () {
    },
    components: {
      alertSuccess: () => import('@/views/dashboard/components/AlertSuccess'),
      alertError: () => import('@/views/dashboard/components/AlertError'),
    },
    data () {
      return {
        ...inputVars(),
        ...apiVars('consumerLoan'),
      }
    },
    computed: {
      ...mapState({
        storeId: state => state.settings.storeId,
        stores: state => state.branchLocation.list,
      }),
      storeName () {
        return this.stores.find(e => e.id === this.storeId).name
      },
    },
    methods: {
      getFields () {
        return {
          'CR No.': 'crNo',
          Debt: 'debt',
          Paid: 'paid',
          Balance: 'balance',
          'Date Loaned': 'dateLoaned',
          'Date Due': 'dateDue',
          'Date Paid': 'datePaid',
          Remarks: 'remark',
        }
      },
      async getConsumerLoan () {
        if (this.consumerLoading || this.loading) return
        this.consumerLoading = true
        const { storeId } = this.$store.state.settings
        try {
          const response = await consumerLoanRepository.statementOfAccount(this.consumerId, { storeId })
            .catch(this.getConsumerLoanErrors)
          this.consumerLoading = false
          const $result = await [].concat.apply([], response.data.map(mapConsumers))
          return $result
        } catch (e) {
          this.getConsumerLoanErrors(e)
        }
        // .then(() => {})
        // .then(() => { this.consumerLoading = false })
      },
      getConsumerLoanErrors (e) {
        this.error = true
        errorDelay(() => { this.error = false })
        this.cnsmrErrors = errorHandler(e)
      },
    },
  }
</script>
